const debtor_groups = {
	add_button: "Schuldnergruppe hinzufügen",
	add_dialog: {
		description: "Fügen Sie eine neue Schuldnergruppe hinzu.",
		form: {
			description: "Beschreibung",
			name: "Name",
		},
		title: "Schuldnergruppe hinzufügen",
	},
	delete_dialog: {
		description: "Möchten Sie die Schuldnergruppe <strong>{{name}}</strong> löschen?",
		group_not_empty: {
			description:
				"Es sind immer noch Schuldner mit dieser Schuldnergruppe verknüpft. Trennen Sie sie, bevor Sie die Schuldnergruppe entfernen.",
			title: "Gruppe ist nicht leer.",
		},
		title: "Schuldnergruppe löschen",
	},
	disconnect_debtor: {
		description: "Möchten Sie den Schuldner <strong>{{name}}</strong> trennen?",
		success_alert: "Trennung des Schuldners war erfolgreich!",
		title: "Schuldner trennen",
		unknown_alert:
			"Trennung des Schuldners war nicht erfolgreich! Bitte versuchen Sie es später erneut.",
	},
	duplicate_dialog: {
		description:
			"Fügen Sie eine neue Schuldnergruppe mit den Werten der ausgewählten Schuldnergruppe hinzu.",
		title: "Schuldnergruppe hinzufügen",
	},
	edit_dialog: {
		description: "Bearbeiten Sie die ausgewählte Schuldnergruppe.",
		title: "Schuldnergruppe bearbeiten",
	},
	status: {
		create: {
			success: "Die Schuldnergruppe wurde hinzugefügt!",
			unknown:
				"Die Schuldnergruppe kann derzeit nicht hinzugefügt werden. Bitte versuchen Sie es später erneut.",
		},
		delete: {
			not_empty:
				"Die Schuldnergruppe kann nicht gelöscht werden, da immer noch Schuldner damit verknüpft sind.",
			success: "Die Schuldnergruppe wurde gelöscht!",
			unknown:
				"Die Schuldnergruppe kann derzeit nicht gelöscht werden. Bitte versuchen Sie es später erneut.",
		},
		edit: {
			success: "Die Schuldnergruppe wurde bearbeitet!",
			unknown:
				"Die ausgewählte Schuldnergruppe kann derzeit nicht bearbeitet werden. Bitte versuchen Sie es später erneut.",
		},
	},
	table: {
		description: "Beschreibung",
		details: "Details",
		name: "Name der Schuldnergruppe",
	},
	title: "Schuldnergruppen",
};

export default debtor_groups;
